import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Последний адрес списка в каждом разделе: `products` → `?q=аспирин&page=3`.
 * Фильтры списков живут в адресе; здесь только память о том, с каким адресом
 * сотрудник ушёл в карточку, — стрелка «назад» возвращает к тому же отбору,
 * даже если по дороге он заглянул в соседний раздел (заказ → клиент → назад).
 * Боковое меню открывает раздел чистым адресом и тем самым память сбрасывает.
 */
const lists = new Map<string, string>()

/** Каркас слушает переходы и запоминает адреса списков (страниц из одного сегмента). */
export function useListMemory(): void {
  const { pathname, search } = useLocation()
  useEffect(() => {
    const parts = pathname.split('/').filter(Boolean)
    if (parts.length === 1 && parts[0]) lists.set(parts[0], search)
  }, [pathname, search])
}

/** `/products` → `/products?q=аспирин&page=3`, если с таким отбором и уходили. */
export function listAddress(list: string): string {
  return list + (lists.get(list.replace(/^\//, '')) ?? '')
}

/** Для тестов: забыть адреса. */
export function resetListMemory(): void {
  lists.clear()
}
